module.exports = __webpack_public_path__ + "static/media/train8-1.b6010d02.png";